module.exports = __webpack_public_path__ + "static/media/surfer-silver-yeti.d53b49d2.png";